export default __webpack_public_path__ + "static/media/people.0e9b5996.png";